import { useContext } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import CafeSearchPage from '../pages/CafeSearchPage';
import NotePage from '../pages/NotePage';
import NoteFeedPage from '../pages/NoteFeedPage';
import NoteGalleryPage from '../pages/NoteGalleryPage';
import NoteCreatePage from '../pages/NoteCreatePage';
import UserProfilePage from '../pages/UserProfilePage';
import UserSettingPage from '../pages/UserSettingPage';
import CafeProfilePage from '../pages/CafeProfilePage';
import CafeCreatePage from '../pages/CafeCreatePage';
import LoginPage from '../pages/LoginPage';
import RegisterPage from '../pages/RegisterPage';
import Unexisting404Page from '../pages/Unexisting404Page';
import RetrievePasswordPage from '../pages/RetrievePasswordPage';
import { Navigate } from 'react-router-dom';
import ResetPasswordPage from '../pages/ResetPasswordPage/ResetPasswordPage';
import LandingPage from '../pages/LandingPage';
import ToolbarLayout from '../components/ui/ToolbarLayout';
import { AppContext } from '../context/ContextProvider';
import CafeEditPage from '../pages/CafeEditPage/CafeEditPage';
import EmailResetPasswordPage from '../pages/EmailResetPasswordPage/EmailResetPasswordPage';

export default function ProtectedRoute() {
  const { isLogin } = useContext(AppContext);

  return (
    <BrowserRouter>
      <Routes>
        {!isLogin && <Route path="/" element={<LandingPage />} />}

        <Route element={<ToolbarLayout />}>
          {isLogin && <Route path="/" element={<Navigate to="/search" replace />} />}
          <Route path="/search" element={<CafeSearchPage />} />
          <Route path="/note" element={<NotePage />} />
          <Route path="/note/:id" element={<NotePage />} />
          <Route path="/note/create" element={<NoteCreatePage />} />
          <Route path="/user/setting" element={<UserSettingPage />} />
          <Route path="/user/:id" element={<UserProfilePage />} />
          <Route path="/cafe" element={<CafeProfilePage />} />
          <Route path="/cafe/create" element={<CafeCreatePage />} />
          <Route path="/cafe/:id/update" element={<CafeEditPage />} />
          <Route path="/cafe/:id" element={<CafeProfilePage />} />
          <Route path="/feed" element={<NoteFeedPage />} />
          <Route path="/note/gallery" element={<NoteGalleryPage style={{ width: '100%' }} />} />
          <Route path="/signin" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/reset-password" element={<RetrievePasswordPage />} />
          <Route path="/notfound" element={<Unexisting404Page />} />
          <Route path="*" element={<Navigate to="/notfound" replace />} />
          <Route path="/reset" element={<ResetPasswordPage />} />
          <Route path="/user/reset-password/:id/:token/" element={<EmailResetPasswordPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
